
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".7","fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.222 52a4.523 4.523 0 01-4.186-2.81L8.366 18.237C7.148 15.26 9.336 12 12.552 12c1.836 0 3.49 1.11 4.186 2.81l12.67 30.953C30.626 48.74 28.438 52 25.222 52z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".7","fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.976 26.566a4.523 4.523 0 00-4.186 2.81l-6.708 16.387C19.864 48.74 22.052 52 25.268 52c1.836 0 3.49-1.11 4.186-2.81l6.708-16.388c1.218-2.976-.971-6.236-4.186-6.236z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".7","fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.005 26.566c1.836 0 3.49 1.11 4.186 2.81l6.708 16.387C44.117 48.74 41.929 52 38.713 52a4.523 4.523 0 01-4.186-2.81l-6.708-16.388c-1.218-2.976.97-6.236 4.186-6.236z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".7","fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.778 52c1.836 0 3.49-1.11 4.186-2.81l12.67-30.953C56.852 15.26 54.664 12 51.448 12a4.523 4.523 0 00-4.186 2.81l-12.67 30.953C33.374 48.74 35.562 52 38.778 52z","fill":"#fff"}})])
          )
        }
      }
    